import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getOktatas, createOktatas, updateOktatas, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import SideTile from "../SideTile";
import { useDropzone } from "react-dropzone";
// import "./Oktatas.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import TopAlert from '../../components/TopAlert';
import {
    MODSZERTANI_OPTIONS,
    PROJEKTFELADATOK_OPTIONS,
    TANTARGYAK_SZAMA_OPTIONS,
    PROJEKT_TEMA_FORRAS_OPTIONS,
    MI_TARTALMAK_OPTIONS,
    KULSO_PARTNER_OPTIONS,
    SZAKKEPZESI_MEGALLAPODAS_OPTIONS,
    KREDITBESZAMITAS_OPTIONS,
    DUALIS_KEPZES_OPTIONS,
    AACSB_LEARNING_GOALS_OPTIONS,
    ABET_STUDENT_OUTCOMES_OPTIONS,
    MERESI_EREDMENYEK_OPTIONS,
    TELJESITMENYBELI_KIHIVASOK_OPTIONS,
    FEJLESZTESI_JAVASLATOK_OPTIONS
} from './OktatOptions';
import { OKTATAS_TRANSLATIONS } from './OktatasTranslations'; 


const OktatasContent = ({ szakKod }) => {

    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const { language, loading } = useLanguage();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [selectedImage, setSelectedImage] = useState(null);
    const [oktatasData, setOktatasData] = useState({
        filling_status: 1,
    });

    // New state for radio button selection
    const [modszertaniValasztas, setModszertaniValasztas] = useState([]);
    const [egyebText, setEgyebText] = useState("");
    const [projektfeladatokValasztas, setProjektfeladatokValasztas] = useState("");
    const [tantargyakSzamaValasztas, setTantargyakSzamaValasztas] = useState("");
    const [projektTemaForrasValasztas, setProjektTemaForrasValasztas] = useState([]);
    const [projektTemaEgyebText, setProjektTemaEgyebText] = useState("");
    const [miTartalmak, setMiTartalmak] = useState([]);
    const [miTartalmakLeirasok, setMiTartalmakLeirasok] = useState({});
    const [miTartalmakMegjegyzes, setMiTartalmakMegjegyzes] = useState("");
    const [kulsoPartnerValasztas, setKulsoPartnerValasztas] = useState("");
    const [szakkepzesiMegallapodasValasztas, setSzakkepzesiMegallapodasValasztas] = useState("");
    const [kreditbeszamitasValasztas, setKreditbeszamitasValasztas] = useState("");
    const [dualisKepzesValasztas, setDualisKepzesValasztas] = useState("");
    const [aacsbLearningGoals, setAacsbLearningGoals] = useState([]);
    const [abetStudentOutcomes, setAbetStudentOutcomes] = useState([]);
    const [meresiEredmenyek, setMeresiEredmenyek] = useState("");
    const [teljesitmenybeliKihivasok, setTeljesitmenybeliKihivasok] = useState([]);
    const [teljesitmenyKihivasokEgyebText, setTeljesitmenyKihivasokEgyebText] = useState("");
    const [fejlesztesiJavaslatok, setFejlesztesiJavaslatok] = useState([]);
    const [fejlesztesiJavaslatokEgyebText, setFejlesztesiJavaslatokEgyebText] = useState("");
    const [fejlesztesiMegjegyzes, setFejlesztesiMegjegyzes] = useState("");

    const [images, setImages] = useState([]);
    const [isNew, setIsNew] = useState(true);
    const [finalized, setFinalized] = useState(false); // To track if the section is finalized
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    
    // Helper function to build JSONB structure for multi-select with descriptions
    const buildMultiSelectWithDescriptions = (selectedValues, descriptions, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            leirasok: descriptions,
            options: options
        };
    };

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue || (Array.isArray(selectedValue) && selectedValue.length === 0)) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    const normalizeSelectionArray = (selection) => {
        if (Array.isArray(selection)) return selection;
        if (!selection) return [];
        return [selection];
    };
    
    // Get translations and options for current language - only after loading is complete
    const t = loading ? {} : (OKTATAS_TRANSLATIONS[language] || OKTATAS_TRANSLATIONS.hu);
    const modszertaniOptions = loading ? [] : (MODSZERTANI_OPTIONS[language] || MODSZERTANI_OPTIONS.hu);
    const projektfeladatokOptions = loading ? [] : (PROJEKTFELADATOK_OPTIONS[language] || PROJEKTFELADATOK_OPTIONS.hu);
    const tantargyakSzamaOptions = loading ? [] : (TANTARGYAK_SZAMA_OPTIONS[language] || TANTARGYAK_SZAMA_OPTIONS.hu);
    const projektTemaForrasOptions = loading ? [] : (PROJEKT_TEMA_FORRAS_OPTIONS[language] || PROJEKT_TEMA_FORRAS_OPTIONS.hu);
    const miTartalmakOptions = loading ? [] : (MI_TARTALMAK_OPTIONS[language] || MI_TARTALMAK_OPTIONS.hu);
    const kulsoPartnerOptions = loading ? [] : (KULSO_PARTNER_OPTIONS[language] || KULSO_PARTNER_OPTIONS.hu);
    const szakkepzesiMegallapodasOptions = loading ? [] : (SZAKKEPZESI_MEGALLAPODAS_OPTIONS[language] || SZAKKEPZESI_MEGALLAPODAS_OPTIONS.hu);
    const kreditbeszamitasOptions = loading ? [] : (KREDITBESZAMITAS_OPTIONS[language] || KREDITBESZAMITAS_OPTIONS.hu);
    const dualisKepzesOptions = loading ? [] : (DUALIS_KEPZES_OPTIONS[language] || DUALIS_KEPZES_OPTIONS.hu);
    const aacsbLearningGoalsOptions = loading ? [] : (AACSB_LEARNING_GOALS_OPTIONS[language] || AACSB_LEARNING_GOALS_OPTIONS.hu);
    const abetStudentOutcomesOptions = loading ? [] : (ABET_STUDENT_OUTCOMES_OPTIONS[language] || ABET_STUDENT_OUTCOMES_OPTIONS.hu);
    const meresiEredmenyekOptions = loading ? [] : (MERESI_EREDMENYEK_OPTIONS[language] || MERESI_EREDMENYEK_OPTIONS.hu);
    const teljesitmenybeliKihivasokOptions = loading ? [] : (TELJESITMENYBELI_KIHIVASOK_OPTIONS[language] || TELJESITMENYBELI_KIHIVASOK_OPTIONS.hu);
    const fejlesztesiJavaslatokOptions = loading ? [] : (FEJLESZTESI_JAVASLATOK_OPTIONS[language] || FEJLESZTESI_JAVASLATOK_OPTIONS.hu);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getOktatas(szakId);
                if (response.data && response.data.data) {
                    const data = response.data.data;
                    setOktatasData(data);
                    setFinalized(data.filling_status === 3);
                    
                    // Load radio button selections from JSONB
                    if (data.modszertani_valasztas) {
                        const selected = data.modszertani_valasztas.selected;
                        setModszertaniValasztas(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.modszertani_egyeb_text) setEgyebText(data.modszertani_egyeb_text);
                    if (data.projektfeladatok_valasztas) setProjektfeladatokValasztas(data.projektfeladatok_valasztas.selected || "");
                    if (data.tantargyak_szama_valasztas) setTantargyakSzamaValasztas(data.tantargyak_szama_valasztas.selected || "");
                    if (data.projekt_tema_forras_valasztas) {
                        const selected = data.projekt_tema_forras_valasztas.selected;
                        setProjektTemaForrasValasztas(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.projekt_tema_egyeb_text) setProjektTemaEgyebText(data.projekt_tema_egyeb_text);
                    if (data.mi_tartalmak) {
                        setMiTartalmak(normalizeSelectionArray(data.mi_tartalmak.selected));
                        setMiTartalmakLeirasok(data.mi_tartalmak.leirasok || {});
                    }
                    if (data.mi_tartalmak_megjegyzes) setMiTartalmakMegjegyzes(data.mi_tartalmak_megjegyzes);
                    if (data.kulso_partner_valasztas) setKulsoPartnerValasztas(data.kulso_partner_valasztas.selected || "");
                    if (data.szakkepzesi_megallapodas_valasztas) setSzakkepzesiMegallapodasValasztas(data.szakkepzesi_megallapodas_valasztas.selected || "");
                    if (data.kreditbeszamitas_valasztas) setKreditbeszamitasValasztas(data.kreditbeszamitas_valasztas.selected || "");
                    if (data.dualis_kepzes_valasztas) setDualisKepzesValasztas(data.dualis_kepzes_valasztas.selected || "");
                    if (data.aacsb_learning_goals) {
                        const selected = data.aacsb_learning_goals.selected;
                        setAacsbLearningGoals(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.abet_student_outcomes) {
                        const selected = data.abet_student_outcomes.selected;
                        setAbetStudentOutcomes(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.meresi_eredmenyek) setMeresiEredmenyek(data.meresi_eredmenyek.selected || "");
                    if (data.teljesitmenybeli_kihivasok) {
                        setTeljesitmenybeliKihivasok(normalizeSelectionArray(data.teljesitmenybeli_kihivasok.selected));
                    }
                    if (data.teljesitmeny_kihivasok_egyeb_text) setTeljesitmenyKihivasokEgyebText(data.teljesitmeny_kihivasok_egyeb_text);
                    if (data.fejlesztesi_javaslatok) {
                        setFejlesztesiJavaslatok(normalizeSelectionArray(data.fejlesztesi_javaslatok.selected));
                    }
                    if (data.fejlesztesi_javaslatok_egyeb_text) setFejlesztesiJavaslatokEgyebText(data.fejlesztesi_javaslatok_egyeb_text);
                    if (data.fejlesztesi_megjegyzes) setFejlesztesiMegjegyzes(data.fejlesztesi_megjegyzes);
                    
                    setIsNew(false);
                    await fetchImages();
                } else {
                    // Handle case when no record exists (404)
                    const newData = {
                        filling_status: 1,
                    };
                    await createOktatas(szakId, newData);
                    setOktatasData(newData);
                    window.location.reload();
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [szakId]);

    const fetchImages = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/images/oktatas_image`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch images');
            }

            const data = await response.json();
            setImages(data.data || []);
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    const handleChange = (field, value) => {
        setOktatasData(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    const handleModszertaniCheckboxChange = (value) => {
        const exclusiveValue = 'nincs_tervezett';
        const isExclusive = value === exclusiveValue;

        setModszertaniValasztas(prevValues => {
            if (prevValues.includes(value)) {
                // Deselecting an option
                return prevValues.filter(item => item !== value);
            } else {
                // Selecting an option
                if (isExclusive) {
                    // If selecting the exclusive option, clear all others
                    return [value];
                } else {
                    // If selecting a non-exclusive option, remove the exclusive one
                    return [...prevValues.filter(item => item !== exclusiveValue), value];
                }
            }
        });

        if (value !== 'egyeb' && !modszertaniValasztas.includes(value)) {
            setEgyebText("");
        }
    };

    const handleEgyebTextChange = (value) => {
        setEgyebText(value);
    };

    const handleTeljesitmenyKihivasokEgyebTextChange = (value) => {
        setTeljesitmenyKihivasokEgyebText(value);
    };

    const handleFejlesztesiJavaslatokEgyebTextChange = (value) => {
        setFejlesztesiJavaslatokEgyebText(value);
    };

    const handleFejlesztesiMegjegyzes = (value) => {
        setFejlesztesiMegjegyzes(value);
    };

    const handleProjektfeladatokRadioChange = (value) => {
        setProjektfeladatokValasztas(value);
    };

    const handleTantargyakSzamaRadioChange = (value) => {
        setTantargyakSzamaValasztas(value);
    };

    const handleProjektTemaForrasCheckboxChange = (value) => {
        setProjektTemaForrasValasztas(prevValues => {
            if (prevValues.includes(value)) {
                return prevValues.filter(item => item !== value);
            } else {
                return [...prevValues, value];
            }
        });

        if (value !== 'egyeb' && !projektTemaForrasValasztas.includes(value)) {
            setProjektTemaEgyebText("");
        }
    };

    const handleProjektTemaEgyebTextChange = (value) => {
        setProjektTemaEgyebText(value);
    };

    const handleMiTartalmakCheckboxChange = (field) => {
        setMiTartalmak((prevValues) => {
            if (prevValues.includes(field)) {
                return prevValues.filter((item) => item !== field);
            }
            return [...prevValues, field];
        });
    };

    const handleMiTartalmakRadioChange = (value) => {
        setMiTartalmak(normalizeSelectionArray(value));
        if (value === 'nincs_mi' || value === 'egyeb') {
            setMiTartalmakMegjegyzes("");
        }
    };

    const handleMiTartalmakMegjegyzes = (value) => {
        setMiTartalmakMegjegyzes(value);
    };

    const handleKulsoPartnerRadioChange = (value) => {
        setKulsoPartnerValasztas(value);
    };

    const handleSzakkepzesiMegallapodasRadioChange = (value) => {
        setSzakkepzesiMegallapodasValasztas(value);
    };

    const handleKreditbeszamitasRadioChange = (value) => {
        setKreditbeszamitasValasztas(value);
    };

    const handleDualisKepzesRadioChange = (value) => {
        setDualisKepzesValasztas(value);
    };

    const handleAacsbCheckboxChange = (value) => {
        const exclusiveValue = 'nem_tortent';
        const isExclusive = value === exclusiveValue;

        setAacsbLearningGoals(prevValues => {
            if (prevValues.includes(value)) {
                return prevValues.filter(item => item !== value);
            } else {
                if (isExclusive) {
                    return [value];
                } else {
                    return [...prevValues.filter(item => item !== exclusiveValue), value];
                }
            }
        });
        // Clear ABET selection when AACSB is selected
        if (value !== exclusiveValue || aacsbLearningGoals.length === 0) {
            setAbetStudentOutcomes([]);
        }
    };

    const handleAbetCheckboxChange = (value) => {
        const exclusiveValue = 'nem_tortent_so';
        const isExclusive = value === exclusiveValue;

        setAbetStudentOutcomes(prevValues => {
            if (prevValues.includes(value)) {
                return prevValues.filter(item => item !== value);
            } else {
                if (isExclusive) {
                    return [value];
                } else {
                    return [...prevValues.filter(item => item !== exclusiveValue), value];
                }
            }
        });
        // Clear AACSB selection when ABET is selected
        if (value !== exclusiveValue || abetStudentOutcomes.length === 0) {
            setAacsbLearningGoals([]);
        }
    };

    const handleMeresiEredmenyekRadioChange = (value) => {
        setMeresiEredmenyek(value);
    };

    const handleTeljesitmenybeliKihivasokCheckboxChange = (value) => {
        setTeljesitmenybeliKihivasok((prevValues) => {
            if (prevValues.includes(value)) {
                return prevValues.filter((item) => item !== value);
            }
            return [...prevValues, value];
        });
    };

    const handleFejlesztesiJavaslatokCheckboxChange = (value) => {
        setFejlesztesiJavaslatok((prevValues) => {
            if (prevValues.includes(value)) {
                return prevValues.filter((item) => item !== value);
            }
            return [...prevValues, value];
        });
    };


    const handleDrop = async (acceptedFiles) => {
        if (finalized) return; // Disable if finalized
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);
        formData.append('section', 'oktatas_image');
    
        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            // Token nélküli feltöltési kérés
            const response = await fetch(`${baseUrl}/upload/${szakId}`, {
                method: 'POST',
                body: formData,
            });
    
            if (!response.ok) {
                throw new Error('Failed to upload image');
            }
    
            const uploadResponse = await response.json();
    
            if (uploadResponse && uploadResponse.image_path) {
                const imagePath = uploadResponse.image_path.replace('uploads/', '');
                setImages((prevImages) => [...prevImages, { ...uploadResponse, image_path: imagePath }]);
            } else {
                console.error('Unexpected response format:', uploadResponse);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };
    

    const handleDeleteImage = async (imageId) => {
        if (finalized) return; // Disable if finalized
        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakjelentes_letrehozas/${szakId}/images/${imageId}`, {
                method: 'DELETE',
            });
            setImages(images.filter(img => img.id !== imageId));
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...oktatasData, 
                filling_status: 2,
                modszertani_valasztas: buildRadioData(modszertaniValasztas, modszertaniOptions),
                modszertani_egyeb_text: egyebText,
                projektfeladatok_valasztas: buildRadioData(projektfeladatokValasztas, projektfeladatokOptions),
                tantargyak_szama_valasztas: buildRadioData(tantargyakSzamaValasztas, tantargyakSzamaOptions),
                projekt_tema_forras_valasztas: projektTemaForrasValasztas.length > 0 ? buildMultiSelectWithDescriptions(projektTemaForrasValasztas, {}, projektTemaForrasOptions) : null,
                projekt_tema_egyeb_text: projektTemaEgyebText,
                mi_tartalmak: {
                    selected: miTartalmak,
                    leirasok: miTartalmakLeirasok,
                    options: miTartalmakOptions
                },
                mi_tartalmak_megjegyzes: miTartalmakMegjegyzes,
                kulso_partner_valasztas: buildRadioData(kulsoPartnerValasztas, kulsoPartnerOptions),
                szakkepzesi_megallapodas_valasztas: buildRadioData(szakkepzesiMegallapodasValasztas, szakkepzesiMegallapodasOptions),
                kreditbeszamitas_valasztas: buildRadioData(kreditbeszamitasValasztas, kreditbeszamitasOptions),
                dualis_kepzes_valasztas: buildRadioData(dualisKepzesValasztas, dualisKepzesOptions),
                aacsb_learning_goals: aacsbLearningGoals.length > 0 ? buildMultiSelectWithDescriptions(aacsbLearningGoals, {}, aacsbLearningGoalsOptions) : null,
                abet_student_outcomes: abetStudentOutcomes.length > 0 ? buildMultiSelectWithDescriptions(abetStudentOutcomes, {}, abetStudentOutcomesOptions) : null,
                meresi_eredmenyek: buildRadioData(meresiEredmenyek, meresiEredmenyekOptions),
                teljesitmenybeli_kihivasok: buildRadioData(teljesitmenybeliKihivasok, teljesitmenybeliKihivasokOptions),
                teljesitmeny_kihivasok_egyeb_text: teljesitmenyKihivasokEgyebText,
                fejlesztesi_javaslatok: buildRadioData(fejlesztesiJavaslatok, fejlesztesiJavaslatokOptions),
                fejlesztesi_javaslatok_egyeb_text: fejlesztesiJavaslatokEgyebText,
                fejlesztesi_megjegyzes: fejlesztesiMegjegyzes
            };
            try {
                if (isNew) {
                    await createOktatas(szakId, updatedData);
                } else {
                    await updateOktatas(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [oktatasData, isNew, szakId, registerSaveHandler, unregisterSaveHandler, 
        modszertaniValasztas, egyebText, projektfeladatokValasztas, tantargyakSzamaValasztas,
        projektTemaForrasValasztas, projektTemaEgyebText, miTartalmak, miTartalmakLeirasok,
        miTartalmakMegjegyzes, kulsoPartnerValasztas, szakkepzesiMegallapodasValasztas,
        kreditbeszamitasValasztas, dualisKepzesValasztas, aacsbLearningGoals, abetStudentOutcomes,
        meresiEredmenyek, teljesitmenybeliKihivasok, teljesitmenyKihivasokEgyebText,
        fejlesztesiJavaslatok, fejlesztesiJavaslatokEgyebText, fejlesztesiMegjegyzes]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        
        // Build JSONB structures with selected values and option definitions
        const updatedData = { 
            ...oktatasData, 
            filling_status: status,
            modszertani_valasztas: buildRadioData(modszertaniValasztas, modszertaniOptions),
            modszertani_egyeb_text: egyebText,
            projektfeladatok_valasztas: buildRadioData(projektfeladatokValasztas, projektfeladatokOptions),
            tantargyak_szama_valasztas: buildRadioData(tantargyakSzamaValasztas, tantargyakSzamaOptions),
            projekt_tema_forras_valasztas: projektTemaForrasValasztas.length > 0 ? buildMultiSelectWithDescriptions(projektTemaForrasValasztas, {}, projektTemaForrasOptions) : null,
            projekt_tema_egyeb_text: projektTemaEgyebText,
            mi_tartalmak: {
                selected: miTartalmak,
                leirasok: miTartalmakLeirasok,
                options: miTartalmakOptions
            },
            mi_tartalmak_megjegyzes: miTartalmakMegjegyzes,
            kulso_partner_valasztas: buildRadioData(kulsoPartnerValasztas, kulsoPartnerOptions),
            szakkepzesi_megallapodas_valasztas: buildRadioData(szakkepzesiMegallapodasValasztas, szakkepzesiMegallapodasOptions),
            kreditbeszamitas_valasztas: buildRadioData(kreditbeszamitasValasztas, kreditbeszamitasOptions),
            dualis_kepzes_valasztas: buildRadioData(dualisKepzesValasztas, dualisKepzesOptions),
            aacsb_learning_goals: aacsbLearningGoals.length > 0 ? buildMultiSelectWithDescriptions(aacsbLearningGoals, {}, aacsbLearningGoalsOptions) : null,
            abet_student_outcomes: abetStudentOutcomes.length > 0 ? buildMultiSelectWithDescriptions(abetStudentOutcomes, {}, abetStudentOutcomesOptions) : null,
            meresi_eredmenyek: buildRadioData(meresiEredmenyek, meresiEredmenyekOptions),
            teljesitmenybeli_kihivasok: buildRadioData(teljesitmenybeliKihivasok, teljesitmenybeliKihivasokOptions),
            teljesitmeny_kihivasok_egyeb_text: teljesitmenyKihivasokEgyebText,
            fejlesztesi_javaslatok: buildRadioData(fejlesztesiJavaslatok, fejlesztesiJavaslatokOptions),
            fejlesztesi_javaslatok_egyeb_text: fejlesztesiJavaslatokEgyebText,
            fejlesztesi_megjegyzes: fejlesztesiMegjegyzes
        };

        try {
            if (isNew) {
                await createOktatas(szakId, updatedData);
            } else {
                await updateOktatas(szakId, updatedData);
            }

            window.location.reload(); // Reload the page after save or finalize
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/szak-letszam-adatok`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/fejlesztesi-javaslatok`);
    };

    const isFormValid = () => {
        // All radio button groups must have a selection, but EITHER aacsbLearningGoals OR abetStudentOutcomes (not both required)
        const miTartalmakArray = normalizeSelectionArray(miTartalmak);

        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // Detailed validation checks for debugging
        const checks = {
            modszertani: modszertaniValasztas.length > 0,
            projektfeladatok: !!projektfeladatokValasztas,
            tantargyakSzama: !!tantargyakSzamaValasztas,
            projektTemaForras: projektTemaForrasValasztas.length > 0,
            miTartalmak: miTartalmakArray.length > 0,
            kulsoPartner: !!kulsoPartnerValasztas,
            szakkepzesiMegallapodas: !!szakkepzesiMegallapodasValasztas,
            kreditbeszamitas: !!kreditbeszamitasValasztas,
            dualisKepzes: !!dualisKepzesValasztas,
            learningGoalsOrOutcomes: (aacsbLearningGoals.length > 0 || abetStudentOutcomes.length > 0),
            meresiEredmenyek: !!meresiEredmenyek,
            teljesitmenybeliKihivasok: teljesitmenybeliKihivasok.length > 0,
            fejlesztesiJavaslatok: fejlesztesiJavaslatok.length > 0
        };

        const hasAllRadioSelections = Object.values(checks).every(check => check);

        // Helper function to check if HTML content has actual text
        const hasContent2 = (html) => {
            if (!html) return false;
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        // Check conditional text fields only when they are relevant
        const egyebFieldsValid = 
            (!modszertaniValasztas.includes('egyeb') || hasContent(egyebText)) &&
            (!projektTemaForrasValasztas.includes('egyeb') || hasContent(projektTemaEgyebText)) &&
            // For each selected MI option (except nincs_mi), the description field below it must be filled
            miTartalmakArray.every(option => 
                option === 'nincs_mi' || 
                hasContent2(miTartalmakLeirasok[option])
            ) &&
            (!teljesitmenybeliKihivasok.includes('egyeb') || hasContent(teljesitmenyKihivasokEgyebText)) &&
            (!fejlesztesiJavaslatok.includes('egyeb') || hasContent(fejlesztesiJavaslatokEgyebText));

        const isValid = hasAllRadioSelections && egyebFieldsValid;
        
        // Log validation results for debugging
        if (!isValid) {
            const failedChecks = Object.entries(checks)
                .filter(([_, value]) => !value)
                .map(([key, _]) => key);
            console.warn('❌ Form validation failed. Failed checks:', failedChecks);
            console.warn('❌ Valid conditional fields:', egyebFieldsValid);
            if (!egyebFieldsValid) {
                console.warn('Conditional field issues:',
                    { modszertaniHasEgyeb: modszertaniValasztas.includes('egyeb'), egyebTextEmpty: !hasContent(egyebText) },
                    { projektTemaHasEgyeb: projektTemaForrasValasztas.includes('egyeb'), projektTemaEgyebEmpty: !hasContent(projektTemaEgyebText) },
                    { miLeirasok: miTartalmakLeirasok },
                    { teljesitmenyHasEgyeb: teljesitmenybeliKihivasok.includes('egyeb'), teljesitmenyEgyebEmpty: !hasContent(teljesitmenyKihivasokEgyebText) },
                    { fejlesztesiHasEgyeb: fejlesztesiJavaslatok.includes('egyeb'), fejlesztesiEgyebEmpty: !hasContent(fejlesztesiJavaslatokEgyebText) }
                );
            }
        }

        return isValid;
    };

    const handleFinalize = (e) => {
        if (finalized) {
            // Visszavonás - használjuk a handleSubmit-ot a konzisztencia érdekében
            handleSubmit(e, 2);
        } else {
            console.log('handleFinalize called - checking form validity');
            console.log('Current state:', {
                modszertaniValasztas,
                projektfeladatokValasztas,
                tantargyakSzamaValasztas,
                projektTemaForrasValasztas,
                miTartalmak,
                kulsoPartnerValasztas,
                szakkepzesiMegallapodasValasztas,
                kreditbeszamitasValasztas,
                dualisKepzesValasztas,
                aacsbLearningGoals,
                abetStudentOutcomes,
                meresiEredmenyek,
                teljesitmenybeliKihivasok,
                fejlesztesiJavaslatok
            });
            
            if (isFormValid()) {
                handleSubmit(e, 3); // Véglegesítés
            } else {
                // Show top alert instead of native alert with more specific message
                const missingFields = [];
                if (!modszertaniValasztas.length) missingFields.push('Section 1 (Methods)');
                if (!projektfeladatokValasztas) missingFields.push('Section 2.1 (Project Tasks)');
                if (!tantargyakSzamaValasztas) missingFields.push('Section 2.2 (Number of Courses)');
                if (!projektTemaForrasValasztas.length) missingFields.push('Section 2.3 (Project Theme Sources)');
                if (!miTartalmak.length) missingFields.push('Section 3 (AI Contents)');
                if (!kulsoPartnerValasztas) missingFields.push('Section 4 (External Partners)');
                if (!szakkepzesiMegallapodasValasztas) missingFields.push('Section 5.1 (VET Agreements)');
                if (!kreditbeszamitasValasztas) missingFields.push('Section 5.2 (Credit Recognition)');
                if (!dualisKepzesValasztas) missingFields.push('Section 6 (Dual Education)');
                if (!aacsbLearningGoals.length && !abetStudentOutcomes.length) missingFields.push('Section 7 (Learning Goals or Student Outcomes)');
                if (!meresiEredmenyek) missingFields.push('Section 8 (Measurement Results)');
                if (!teljesitmenybeliKihivasok.length) missingFields.push('Section 9 (Performance Challenges)');
                if (!fejlesztesiJavaslatok.length) missingFields.push('Section 10 (Development Proposals)');
                
                const detailMessage = missingFields.length > 0 
                    ? `${t.alerts.requiredFields}\n\nMissing: ${missingFields.join(', ')}`
                    : t.alerts.requiredFields;
                
                setAlertMessage(detailMessage);
                setShowAlert(true);
            }
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop,
        accept: 'image/*',
        disabled: finalized // Disable if finalized
    });

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        <h2>{t.section1.title}</h2>
                        <div className="form-group">
                            {modszertaniOptions.map((option) => {
                                const exclusiveValue = 'nincs_tervezett';
                                const hasExclusiveSelected = modszertaniValasztas.includes(exclusiveValue);
                                const shouldDisable = hasExclusiveSelected && option.value !== exclusiveValue;

                                return (
                                    <div className="checkbox-group" key={option.value}>
                                        <input
                                            type="checkbox"
                                            id={`modszertani_${option.value}`}
                                            name="modszertani"
                                            value={option.value}
                                            checked={modszertaniValasztas.includes(option.value)}
                                            onChange={() => handleModszertaniCheckboxChange(option.value)}
                                            disabled={finalized || shouldDisable}
                                        />
                                        <label htmlFor={`modszertani_${option.value}`}>{option.label}</label>
                                    </div>
                                );
                            })}
                            {modszertaniValasztas.includes('egyeb') && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="egyeb_modszertani"
                                        value={egyebText}
                                        onChange={handleEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="card">
                        <h2>{t.section2.title}</h2>
                        <h4>{t.section2.question1}</h4>
                        <div className="form-group">
                            {projektfeladatokOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`projektfeladatok_${option.value}`}
                                        name="projektfeladatok"
                                        value={option.value}
                                        checked={projektfeladatokValasztas === option.value}
                                        onChange={(e) => handleProjektfeladatokRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`projektfeladatok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section2.question2}</h4>
                        <div className="form-group">
                            {tantargyakSzamaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`tantargyak_szama_${option.value}`}
                                        name="tantargyak_szama"
                                        value={option.value}
                                        checked={tantargyakSzamaValasztas === option.value}
                                        onChange={(e) => handleTantargyakSzamaRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`tantargyak_szama_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section2.question3}</h4>
                        <div className="form-group">
                            {projektTemaForrasOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`projekt_tema_forras_${option.value}`}
                                        name="projekt_tema_forras"
                                        value={option.value}
                                        checked={projektTemaForrasValasztas.includes(option.value)}
                                        onChange={() => handleProjektTemaForrasCheckboxChange(option.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`projekt_tema_forras_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {projektTemaForrasValasztas.includes('egyeb') && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="projekt_tema_egyeb_text"
                                        value={projektTemaEgyebText}
                                        onChange={handleProjektTemaEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>

                    </div>
                    

                    <div className="card">
                        <h2>{t.section3.title}</h2>
                        <h4>{t.section3.question}</h4>
                        <div className="form-group">
                            {miTartalmakOptions.map((option) => (
                                <div key={option.value} style={{ marginBottom: '10px' }}>
                                    <div className="checkbox-group">
                                        <input
                                            type="checkbox"
                                            id={`mi_tartalmak_${option.value}`}
                                            name="mi_tartalmak"
                                            value={option.value}
                                            checked={miTartalmak.includes(option.value)}
                                            onChange={(e) => {
                                                const noMiValue = 'nincs_mi';
                                                if (e.target.checked) {
                                                    if (option.value === noMiValue) {
                                                        setMiTartalmak([noMiValue]);
                                                        setMiTartalmakLeirasok({});
                                                    } else {
                                                        setMiTartalmak([...miTartalmak.filter(val => val !== noMiValue), option.value]);
                                                    }
                                                } else {
                                                    setMiTartalmak(miTartalmak.filter(val => val !== option.value));
                                                    const newLeirasok = { ...miTartalmakLeirasok };
                                                    delete newLeirasok[option.value];
                                                    setMiTartalmakLeirasok(newLeirasok);
                                                }
                                            }}
                                            disabled={finalized}
                                        />
                                        <label htmlFor={`mi_tartalmak_${option.value}`}>{option.label}</label>
                                    </div>
                                    {miTartalmak.includes(option.value) && option.value !== 'nincs_mi' && (
                                        <div className="egyeb-editor-container" style={{ marginLeft: '30px', marginTop: '10px' }}>
                                            <RichTextEditor
                                                name={`mi_leiras_${option.value}`}
                                                value={miTartalmakLeirasok[option.value] || ""}
                                                onChange={(value) => setMiTartalmakLeirasok({
                                                    ...miTartalmakLeirasok,
                                                    [option.value]: value
                                                })}
                                                disabled={finalized}
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section4.title}</h2>
                        <h4>{t.section4.question}</h4>
                        <div className="form-group">
                            {kulsoPartnerOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kulso_partner_${option.value}`}
                                        name="kulso_partner"
                                        value={option.value}
                                        checked={kulsoPartnerValasztas === option.value}
                                        onChange={(e) => handleKulsoPartnerRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`kulso_partner_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section5.title}</h2>
                        <p>{t.section5.source} <a href="https://seafile.sze.hu/f/ece3711672b34eeab733/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/ece3711672b34eeab733/</a></p>
                        
                        <h4>{t.section5.question1}</h4>
                        <div className="form-group">
                            {szakkepzesiMegallapodasOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`szakkepzesi_megallapodas_${option.value}`}
                                        name="szakkepzesi_megallapodas"
                                        value={option.value}
                                        checked={szakkepzesiMegallapodasValasztas === option.value}
                                        onChange={(e) => handleSzakkepzesiMegallapodasRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`szakkepzesi_megallapodas_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.section5.question2}</h4>
                        <p>{t.section5.description}</p>
                        <div className="form-group">
                            {kreditbeszamitasOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`kreditbeszamitas_${option.value}`}
                                        name="kreditbeszamitas"
                                        value={option.value}
                                        checked={kreditbeszamitasValasztas === option.value}
                                        onChange={(e) => handleKreditbeszamitasRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`kreditbeszamitas_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section6.title}</h2>
                        <p>{t.section6.source} <a href="https://seafile.sze.hu/f/0e225a96e4504f49a056/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/0e225a96e4504f49a056/</a></p>
                        
                        <h4>{t.section6.question}</h4>
                        <div className="form-group">
                            {dualisKepzesOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`dualis_kepzes_${option.value}`}
                                        name="dualis_kepzes"
                                        value={option.value}
                                        checked={dualisKepzesValasztas === option.value}
                                        onChange={(e) => handleDualisKepzesRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`dualis_kepzes_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section7.mainTitle}</h2>
                        <h2>{t.section7.aacsbTitle}</h2>
                        <p>{t.section7.aacsbDescription1}</p>
                        <p>{t.section7.aacsbDescription2}</p>
                        
                        <h4>{t.section7.aacsbQuestion}</h4>
                        <div className="form-group">
                            {aacsbLearningGoalsOptions.map((option) => {
                                const exclusiveValue = 'nem_tortent';
                                const hasExclusiveSelected = aacsbLearningGoals.includes(exclusiveValue);
                                const shouldDisable = hasExclusiveSelected && option.value !== exclusiveValue;

                                return (
                                    <div className="checkbox-group" key={option.value}>
                                        <input
                                            type="checkbox"
                                            id={`aacsb_learning_goals_${option.value}`}
                                            name="aacsbLearningGoals"
                                            value={option.value}
                                            checked={aacsbLearningGoals.includes(option.value)}
                                            onChange={() => handleAacsbCheckboxChange(option.value)}
                                            disabled={finalized || shouldDisable}
                                        />
                                        <label htmlFor={`aacsb_learning_goals_${option.value}`}>{option.label}</label>
                                    </div>
                                );
                            })}
                        </div>

                        <h2>{t.section7.abetTitle}</h2>
                        <p>{t.section7.abetDescription1}</p>
                        <p>{t.section7.abetDescription2}</p>
                        
                        <h4>{t.section7.abetQuestion}</h4>
                        <div className="form-group">
                            {abetStudentOutcomesOptions.map((option) => {
                                const exclusiveValue = 'nem_tortent_so';
                                const hasExclusiveSelected = abetStudentOutcomes.includes(exclusiveValue);
                                const shouldDisable = hasExclusiveSelected && option.value !== exclusiveValue;

                                return (
                                    <div className="checkbox-group" key={option.value}>
                                        <input
                                            type="checkbox"
                                            id={`abet_student_outcomes_${option.value}`}
                                            name="abetStudentOutcomes"
                                            value={option.value}
                                            checked={abetStudentOutcomes.includes(option.value)}
                                            onChange={() => handleAbetCheckboxChange(option.value)}
                                            disabled={finalized || shouldDisable}
                                        />
                                        <label htmlFor={`abet_student_outcomes_${option.value}`}>{option.label}</label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="card" >
                        <h2>{t.section8.title}</h2>
                        <div className="form-group">
                            {meresiEredmenyekOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`meresi_eredmenyek_${option.value}`}
                                        name="meresiEredmenyek"
                                        value={option.value}
                                        checked={meresiEredmenyek === option.value}
                                        onChange={(e) => handleMeresiEredmenyekRadioChange(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`meresi_eredmenyek_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="card" >
                        <h2>{t.section9.title}</h2>
                        <div className="form-group">
                            {teljesitmenybeliKihivasokOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`teljesitmenybeli_kihivasok_${option.value}`}
                                        name={`teljesitmenybeliKihivasok_${option.value}`}
                                        value={option.value}
                                        checked={teljesitmenybeliKihivasok.includes(option.value)}
                                        onChange={() => handleTeljesitmenybeliKihivasokCheckboxChange(option.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`teljesitmenybeli_kihivasok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {teljesitmenybeliKihivasok.includes("egyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="teljesitmeny_kihivasok_egyeb_text"
                                        value={teljesitmenyKihivasokEgyebText}
                                        onChange={handleTeljesitmenyKihivasokEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card">
                        <h2>{t.section10.title}</h2>
                        <div className="form-group">
                            {fejlesztesiJavaslatokOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`fejlesztesi_javaslatok_${option.value}`}
                                        name={`fejlesztesiJavaslatok_${option.value}`}
                                        value={option.value}
                                        checked={fejlesztesiJavaslatok.includes(option.value)}
                                        onChange={() => handleFejlesztesiJavaslatokCheckboxChange(option.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`fejlesztesi_javaslatok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {fejlesztesiJavaslatok.includes("egyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="fejlesztesi_javaslatok_egyeb_text"
                                        value={fejlesztesiJavaslatokEgyebText}
                                        onChange={handleFejlesztesiJavaslatokEgyebTextChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                        
                        <h4>{t.section10.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="fejlesztesi_megjegyzes"
                                value={fejlesztesiMegjegyzes}
                                onChange={handleFejlesztesiMegjegyzes}
                                disabled={finalized}
                            />
                        </div>
                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" onClick={handleBack}>{t.buttons.previous}</button>
                        <button className="szak-button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>
                            {finalized ? t.buttons.unfinalize : t.buttons.finalize}
                        </button>
                    </div>

                </form>
            </div>
        </div>
        </div>
    );
};

// Wrapper component that provides language context
const Oktatas = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <OktatasContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default Oktatas;
